import { StateService, Transition } from '@uirouter/angularjs';
import { IScope } from 'angular';
import {
  StateTransitionStartedAction,
  StateTransitionSucceedAction
} from './app.action';
import { Action } from './common/actions/core/action';
import ActionDispatcherService from './common/actions/core/action-dispatcher.service';
import { ActionHandler } from './common/actions/core/action-handler';
import AuthService from './common/services/auth/auth.service';
import {
  AuthenticationError,
  AuthorizationError
} from './common/services/error/error.action';
import UserService from './common/services/user/user.service';
import { OpenLoginDialogAction } from './components/login-dialog/login-dialog.action';
import SecuredStorage from './common/services/local-storage/secured-storage.service';

/* @ngInject */
export default class AppActionHandler implements ActionHandler {
  private reauthorizingInProgress = false;

  constructor(
    private actionDispatcher: ActionDispatcherService,
    private authService: AuthService,
    private $state,
    private userService: UserService,
    private $transitions,
    private $rootScope: IScope,
    private securedStorage: SecuredStorage
  ) {
    this.setupTransitions();
  }

  public handle(action: Action) {
    if (action instanceof AuthenticationError) {
      this.authService.onAuthenticationDiscarded();
      this.actionDispatcher.dispatch(new OpenLoginDialogAction());
    }
    if (action instanceof AuthorizationError) {
      if (this.reauthorizingInProgress === false) {
        // Try to reauthorize access only once to avoid circular reloads.
        this.authService.authorize().then(authorize => {
          this.reauthorizingInProgress = true;
          this.$state.reload().finally(() => {
            this.reauthorizingInProgress = false;
          });
        });
      }
    }
  }

  private setupTransitions(): void {
    const unsubscribers = [
      this.$transitions.onStart({}, transition =>
        this.onTransitionStarted(transition)
      ),
      this.$transitions.onSuccess({}, transition =>
        this.onTransitionSucceed(transition)
      ),
      this.$transitions.onError({}, transition =>
        this.onTransitionError(transition)
      )
    ];
    this.$rootScope.$on('$destroy', () => {
      unsubscribers.forEach(unsubscriber => {
        if (angular.isFunction(unsubscriber)) {
          unsubscriber();
        }
      });
    });
  }

  private onTransitionStarted(transition: Transition) {
    this.actionDispatcher.dispatch(
      new StateTransitionStartedAction(transition)
    );

    return this.userService.isAuthenticated().then(authenticated => {
      if (
        !authenticated &&
        ['login', 'mobileconnect', 'noAuthBuy', 'noAuthOffers'].indexOf(transition.$to().name) === -1
      ) {
        if(window.location.href.indexOf("/family-plan-member?token=") > -1 ){
          this.securedStorage.set("currentRedirectURL", window.location.href);
        }
        if (window.location.href.indexOf("/buy/") > -1) {
          var offerId = window.location.href.split('/buy/')[1].split('?')[0];
          var params = transition.params();
          return this.$state.target('noAuthBuy', { packetId: offerId, ...params });
        }
        if (window.location.href.indexOf("/offers") > -1) {
          return this.$state.target('noAuthOffers', { transition });
        }
        return this.$state.target('login', { transition });
      } else if (authenticated && transition.$to().name === 'login') {
        if(!!this.securedStorage.get("currentRedirectURL") && this.securedStorage.get("currentRedirectURL").includes(".fizy.com")){
          const redirectURL = this.securedStorage.get("currentRedirectURL");
          this.securedStorage.remove("currentRedirectURL");
          window.location.href = redirectURL;
        } else{
          return this.$state.target('myAccount', { transition });
        }
      } else if (authenticated && transition.$to().name === 'noAuthBuy') {
        var offerId = window.location.href.split('/buy/')[1].split('?')[0];
        var params = transition.params();
        return this.$state.target('buy', { packetId: offerId, ...params });
      } else if (authenticated && transition.$to().name === 'noAuthOffers') {
        return this.$state.target('myAccount', { transition });
      }
    });
  }

  private onTransitionSucceed(transition: Transition): void {
    this.actionDispatcher.dispatch(
      new StateTransitionSucceedAction(transition)
    );
  }

  private onTransitionError(transition: Transition) {
    // Do nothing so far.
  }
}



// WEBPACK FOOTER //
// ./src/app/app.action-handler.service.ts